// Input / Select — text and dropdown form controls sharing one field look
// (`bg-inset`, subtle border, accent focus). `inputClasses` is exported so
// textareas or other native controls can match without re-deriving the string.
import { InputHTMLAttributes, SelectHTMLAttributes, forwardRef } from 'react';
import { cn } from './cn';

export const inputClasses =
  'w-full px-3 py-2 rounded-md text-sm bg-bg-inset border border-border text-fg ' +
  'placeholder:text-fg-subtle focus:border-accent/60 focus:bg-bg-elevated transition-colors';

export const Input = forwardRef<HTMLInputElement, InputHTMLAttributes<HTMLInputElement>>(
  function Input({ className, ...rest }, ref) {
    return <input ref={ref} className={cn(inputClasses, className)} {...rest} />;
  },
);

export const Select = forwardRef<HTMLSelectElement, SelectHTMLAttributes<HTMLSelectElement>>(
  function Select({ className, ...rest }, ref) {
    return <select ref={ref} className={cn(inputClasses, 'pr-8', className)} {...rest} />;
  },
);
